import React from 'react';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import NcIcon from './NcIcon';
import Logo from './Logo';
import SidebarUserMenu from './SidebarUserMenu';
import './Sidebar.css';

export default function AdminSidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const { role, orgName: ownOrgName, permissions, isOwner } = useAuth();
  const isProvider = role === 'provider';
  const orgId = searchParams.get('org');
  const orgName = searchParams.get('orgName');
  // A qs suffix carried on every nav link while "viewing" an org, so moving
  // between Tenants/Brugere never drops that context.
  const qs = orgId ? `?org=${orgId}${orgName ? `&orgName=${encodeURIComponent(orgName)}` : ''}` : '';

  const isActive = (path) => location.pathname === path;
  // "SAC-IT Team": the organisation's own people, named after the organisation.
  const teamName = `${orgName || ownOrgName || ''} Team`.trim();

  // Provider's own top level (no org selected yet) shows ONLY
  // Organisationer — Tenants/Brugere only appear once they've drilled into
  // a specific org, at which point it's that org's admin view.
  if (isProvider && !orgId) {
    return (
      <aside className="sidebar sidebar--provider">
        <div className="sidebar__brand-row">
          <div className="sidebar__brand" onClick={() => navigate('/organizations')} style={{ cursor: 'pointer' }}>
            <Logo size={29} className="sidebar__brand-icon" />
            <div className="sidebar__brand-divider" />
            <div className="sidebar__brand-stack">
              <span className="sidebar__brand-text">nord<span>comply</span></span>
              <span className="sidebar__portal-badge">Provider Portal</span>
            </div>
          </div>
        </div>
        <nav className="sidebar__nav">
          <div className="sidebar__gl">Kunder</div>
          <button className={`sidebar__link ${isActive('/organizations') ? 'is-active' : ''}`} onClick={() => navigate('/organizations')}>
            <NcIcon name="groups" /> Organisationer
          </button>
          <button className={`sidebar__link ${isActive('/users') ? 'is-active' : ''}`} onClick={() => navigate('/users')}>
            <NcIcon name="teams" /> Brugere
          </button>
          <div className="sidebar__gl">Drift</div>
          <button className={`sidebar__link ${isActive('/activity-log') ? 'is-active' : ''}`} onClick={() => navigate('/activity-log')}>
            <NcIcon name="clock" /> Aktivitetslog
          </button>
          {(isOwner || permissions.includes('licenses')) && (
            <button className={`sidebar__link ${isActive('/licenses') ? 'is-active' : ''}`} onClick={() => navigate('/licenses')}>
              <NcIcon name="tag" /> Licenser
            </button>
          )}
          {(isOwner || permissions.includes('support') || permissions.includes('news')) && <div className="sidebar__gl">Indhold</div>}
          {(isOwner || permissions.includes('support')) && (
            <button className={`sidebar__link ${isActive('/support-admin') ? 'is-active' : ''}`} onClick={() => navigate('/support-admin')}>
              <NcIcon name="info" /> Support
            </button>
          )}
          {(isOwner || permissions.includes('news')) && (
            <button className={`sidebar__link ${isActive('/news') ? 'is-active' : ''}`} onClick={() => navigate('/news')}>
              <NcIcon name="info" /> Nyheder
            </button>
          )}
        </nav>
        <div style={{ flex: 1 }} />
        <SidebarUserMenu />
      </aside>
    );
  }

  return (
    <aside className="sidebar sidebar--tenant">
      <div className="sidebar__brand-row">
        <div className="sidebar__brand" onClick={() => navigate(isProvider ? '/organizations' : '/tenants')} style={{ cursor: 'pointer' }}>
          <Logo size={29} className="sidebar__brand-icon" />
          <div className="sidebar__brand-divider" />
          <div className="sidebar__brand-stack">
            <span className="sidebar__brand-text">nord<span>comply</span></span>
            <span className="sidebar__portal-badge">Tenant Portal</span>
          </div>
        </div>
      </div>

      {isProvider && (
        <nav className="sidebar__nav" style={{ marginBottom: 'var(--space-3)' }}>
          <button className="sidebar__link" onClick={() => navigate('/organizations')}>
            <span aria-hidden="true">←</span> {orgName || 'Organisationer'}
          </button>
        </nav>
      )}

      <nav className="sidebar__nav">
        <div className="sidebar__gl">Kunder</div>
        <button className={`sidebar__link ${isActive('/tenants') || location.pathname.startsWith('/customer/') ? 'is-active' : ''}`} onClick={() => navigate(`/tenants${qs}`)}>
          <NcIcon name="box" /> Kunde tenants
        </button>
        <button className={`sidebar__link ${isActive('/users') ? 'is-active' : ''}`} onClick={() => navigate(`/users${qs}`)}>
          <NcIcon name="teams" /> {teamName}
        </button>
        <div className="sidebar__gl">Hjælp</div>
        <button className={`sidebar__link ${isActive('/support') ? 'is-active' : ''}`} onClick={() => navigate(`/support${qs}`)}>
          <NcIcon name="info" /> Support
        </button>
      </nav>
      <div style={{ flex: 1 }} />
      <SidebarUserMenu />
    </aside>
  );
}
